import {Button, Form, FormInstance, Input} from "antd"
import React, {useEffect, useState} from "react"
import CodiceFiscale from "codice-fiscale-js"
import {fiscalCodeFormItemValidator} from "../../util/fiscalCode.validator"
import CompetitorChooserModal from "../modals/competitor-chooser.modal";
import {ICompetitor} from "../../model/competitor.model";
import moment from 'moment';

interface Props {
    readonly id: number
    readonly restField: { fieldKey?: number | undefined }
    readonly bmillesimo?: boolean
    readonly eventDate?: string
    readonly form: FormInstance
}

const CompetitorComponent = (props: Props) => {
    const [age, setAge] = useState<number | undefined>(undefined)
    const [isModalOpen, setIsModalOpen] = useState(false)

    useEffect(() => {
        calculateAge(props.form.getFieldValue(["competitors", props.id, "fiscalCode"]))
    }, [])

    const showModal = () => {
        setIsModalOpen(true)
    }

    const handleChoosing = (competitor: ICompetitor) => {
        let fiscalCode = ["competitors", props.id, "fiscalCode"];
        let name = ["competitors", props.id, "name"];
        let surname = ["competitors", props.id, "surname"];

        props.form.setFieldValue(fiscalCode, competitor.fiscalCode)
        props.form.setFieldValue(name, competitor.name)
        props.form.setFieldValue(surname, competitor.surname)

        handleFiscalCodeChange(competitor.fiscalCode)

        props.form.validateFields([fiscalCode, name, surname])

        closeModal()
    }

    const closeModal = () => {
        setIsModalOpen(false)
    }

    const handleFiscalCodeChange = (fiscalCode: string | undefined) => {
        if (fiscalCode !== undefined) {
            props.form.setFieldValue(["competitors", props.id, "fiscalCode"], fiscalCode.trim())
            props.form.validateFields(["competitors", props.id, "fiscalCode"])
            calculateAge(fiscalCode);
        } else {
            setAge(undefined)
        }
    }

    const calculateAge = (fiscalCode?: string): void => {
        if (fiscalCode && fiscalCode.trim().length > 0 && CodiceFiscale.check(fiscalCode)) {
            const info = CodiceFiscale.computeInverse(fiscalCode)
            const birthDay = new Date(info.year, info.month - 1, info.day)

            const newAge = !!props.bmillesimo ?
                moment().year() - moment(birthDay).year():
                moment(props.eventDate!).diff(moment(birthDay), 'years')

            setAge(newAge)
        } else {
            setAge(undefined)
        }
    }

    return (
        <>
            <div style={{display: "flex", justifyContent: "space-between"}}>
                <p>Atleta {props.id + 1}</p>
                {age && <p><strong>Età {age}</strong></p>}
                <Button style={{marginTop: "auto", marginBottom: "auto"}} onClick={showModal}>Cerca</Button>
            </div>
            <Form.Item
                {...props.restField}
                label="Codice fiscale"
                name={[props.id, "fiscalCode"]}
                rules={[{required: true, message: 'Codice fiscale obbligatorio'}, fiscalCodeFormItemValidator]}
            >
                <Input onChange={event => handleFiscalCodeChange(event.target.value)}/>
            </Form.Item>
            <Form.Item
                {...props.restField}
                label="Nome"
                name={[props.id, "name"]}
                rules={[{required: true, message: 'Nome obbligatorio'}]}
            >
                <Input/>
            </Form.Item>
            <Form.Item
                {...props.restField}
                label="Cognome"
                name={[props.id, "surname"]}
                rules={[{required: true, message: 'Cognome obbligatorio'}]}
            >
                <Input/>
            </Form.Item>
            <CompetitorChooserModal
                onChoosing={handleChoosing}
                isModalOpen={isModalOpen}
                onClose={closeModal}/>
        </>
    )
}

export default CompetitorComponent